import Vue from 'vue';
import axios from 'axios';
import EpisodeSingle from './components/EpisodeSingle.vue';

axios.defaults.withCredentials = true

export default new Vue({
    render: h => h(EpisodeSingle)
});
